import { render, staticRenderFns } from "./AtualizarFaq.vue?vue&type=template&id=543a9120&scoped=true&"
import script from "./AtualizarFaq.vue?vue&type=script&lang=js&"
export * from "./AtualizarFaq.vue?vue&type=script&lang=js&"
import style0 from "./AtualizarFaq.vue?vue&type=style&index=0&id=543a9120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543a9120",
  null
  
)

export default component.exports